<template>
    <div :id="'radio--' + component_id">
        <div class="designeroption" v-if="options_loaded && passed_filter" :data-designer-component-id="component_id">
            <h3>Add Secured By Design To Your Door</h3>
            <div class="stylesoption">
                <div class="align-center p-3"><img :src="'/images/hurst/sbd.jpg'" alt=""></div>
                <div class="sbd-radio-wrapper">
                    <label>Would you like to upgrade to SBD/Doc Q?</label>
                    <div class="radios _inline">
                        <div class="radio" v-for="option in filtered_option_list">
                            <label>
                                <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value"/>
                                <span class="checkbox-label">{{ option.label }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";

    export default {
        mixins: [
            DesignerQuestionSecuredByDesign
        ],
        props: {
            frameStyle: {
                required: true,
            },
            openingDirection: {
                required: true,
            },
            hardwareLock: {
                required: true,
            },
            threshold: {
                required: true,
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameStyle, this.openingDirection, this.hardwareLock, this.threshold, this.typeRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/secured-by-design?frame_combination=' + this.frameStyle.frame_id + '&opening_direction=' + this.openingDirection + '&hardware_lock=' + this.hardwareLock + '&threshold=' + this.threshold + '&type_range=' + this.typeRange;
            },
            cache_key(){
                return '_' + this.frameStyle.frame_id + '_' + this.openingDirection + '_' + this.hardwareLock + '_' + this.threshold + '_' + this.typeRange;
            },
        },
    }
</script>
